import { render, staticRenderFns } from "./laonianren.vue?vue&type=template&id=16d17ccc&scoped=true&"
import script from "./laonianren.vue?vue&type=script&lang=ts&"
export * from "./laonianren.vue?vue&type=script&lang=ts&"
import style0 from "./laonianren.vue?vue&type=style&index=0&id=16d17ccc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d17ccc",
  null
  
)

export default component.exports